import React, { useContext } from 'react';
import ProductPageContext from '../../contexts/ProductPageContext';
import { replacePlaceholders } from '../../tools/tmntHelpers';

export default function SearchStoresMessage({
  loading,
  error,
  totalStores,
  isDataFetched,
  searchedAddress,
  noResults,
  radius,
}) {
  const ProductPageState = useContext(ProductPageContext);
  const { tmntData } = ProductPageState;

  const getMessage = () => {
    if (loading) {
      return `${tmntData?.findingStoresNear?.value} ${searchedAddress}...`;
    }
    if (error && !loading) {
      return tmntData?.findStoreError?.value;
    }
    if (isDataFetched && (totalStores === 0 || noResults)) {
      return `${tmntData?.noStoresFoundNear?.value} ${searchedAddress}. ${tmntData?.searchDifferentLocation?.value}`;
    }
    if (isDataFetched && !noResults && totalStores > 0) {
      return replacePlaceholders(tmntData?.storesInRadius?.value, { 0: totalStores, 1: radius });
    }
    return tmntData?.storeNear?.value;
  };

  return (
    <p className="store-map-items__header" data-testid="store-map-items__header">
      {getMessage()}
    </p>
  );
}
